import dropdownService from "../services/dropdownService";
import { useMutation } from "react-query";

const useUserListDropdown = (onData) => {
  return useMutation(dropdownService.userListDropdown, {
    onSuccess: (data) => onData(data),
  });
};

const dropdownQueries = {
  useUserListDropdown
};

export default dropdownQueries;
